import FlowConfigAbstract from 'app/components/onboardingFlows/flows/common/FlowConfigAbstract';
import {matchPath, useLocation} from 'react-router';

class NewDistrictMainPageFlow extends FlowConfigAbstract {
  public readonly id = '3';
  public readonly title = 'Dein neues Startseiten-Design ist da! 🎉';
  public readonly description =
    'Das neue Design ist jetzt aktiv und bietet dir einen schnelleren Überblick und eine übersichtlichere Darstellung deiner Inhalte. Vorübergehend kannst du über den Button rechts unten zur alten Ansicht zurückwechseln.';
  public readonly animationSrc = 'district-main-page.json';
  public readonly authProtected = false;
  public readonly reshowInDays = null;

  protected readonly start_time = new Date('2025-02-26');
  protected readonly available_until = new Date('2025-03-31');

  public isAllowedToDisplay(): boolean {
    if (!this.isAvailableAndNotViewed()) {
      return false;
    }

    return this.isSpecificLandingPage();
  }

  private isSpecificLandingPage(): boolean {
    const location = useLocation();
    const match = matchPath(location.pathname, {
      path: this.getPathWhitelist(),
      exact: true,
    });
    return Boolean(match);
  }

  private getPathWhitelist(): String[] {
    return ['/region/:slug'];
  }
}

export default NewDistrictMainPageFlow;
